<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" lg="6" sm="12">
        <v-card>
          <v-list-item>
            <v-list-item-avatar>
                <v-icon>mdi-account-tie</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="headline">取引先情報登録</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-text>
            <v-form ref="suppliers_form" v-model="valid" @submit.prevent>
              <v-text-field label="取引先名" v-model="name" :rules="suppliersNameRules" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field label="備考" v-model="remarks" :rules="remarksRules" dense outlined></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1" class="mr-3" :to="{ name: 'SuppliersMaster' }" depressed>キャンセル</v-btn>
            <v-btn color="primary" @click.prevent="checkDialog" :disabled="!valid" depressed>確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleStore
        @stored="submit" @canceled="dialogCancel"/>
    </v-row>
  </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import statusList from "@/helpers/const";
  import SuppliersApi from "@/api/suppliers-api";
  import CustomDialog from "@/components/custom_ui/CustomDialog";
  import Rule from "@/validation/rules";

  export default {
    name: "CreateSuppliersMaster",
    components: {
      CustomDialog
    },
    data: () => ({
      loading: false,
      // フォームの項目
      name: '',
      remarks: '',

      // 登録ダイアログ
      dialogMaxWith: 500,
      dialogTitle: '',
      dialogItems: [],
      dialogDrawer: false,

      // バリデーション
      valid: true,
      suppliersNameRules: Rule.suppliersNameRules,
      remarksRules: Rule.remarksRules,
    }),
    created () {
      this.initialize();
    },
    methods: {
      isLoading() {
        this.loading = !this.loading;
        this.$emit("loading", this.loading);
      },
      initialize () {
        this.suppliersApi = new SuppliersApi();
      },
      // 登録ボタン押下時イベント
      checkDialog () {
        this.dialogTitle = '登録しますか？';
        this.dialogItems = [
          { name: '取引先名', value: this.name },
          { name: '備考', value: this.remarks },
        ];
        this.dialogDrawer = true;
      },
      dialogCancel() {
        this.dialogDrawer = false;
      },
      // 確認ダイアログの「登録」確定ボタン押下イベント
      submit() {
        if (this.$refs.suppliers_form.validate()) {
          this.isLoading();
          const params = {
            name: this.name,
            remarks: this.remarks,
          };
          const promise = this.suppliersApi.store(params);
          promise.then((response) => {
              this.$router.push({ name: 'SuppliersMaster' });
              this.$emit('success', response.data.message);
          }).catch(error => {
            useAppInsights().trackException({exception: error});
            if (error.response) {
              if (error.response.data.status == statusList.status.authError) {
                this.dialogDrawer = false;
                this.$emit('logoutConform');
              } else {
                this.$emit("error",error.response.data.message);
              }
            } else {
              this.$emit("error","サーバーエラーが発生しました。");
            }
          }).finally(() => {
            this.isLoading();
          });
        }
      }
    }
  };
</script>

